import "../Components/Table_booking/package-lead-submitted.css"
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from 'axios';
import './contactus.css'
import banner from "./image/contact-banner.svg"
import ShowSuccess from "../Components/show-success";
import FaqSection from "../FAQ/FaqSection";
import EventsListingCard from "../event-view-all-page/EventsListingCard";
import { BsWhatsapp } from "react-icons/bs";
import { API_BASE_URL } from "../utils";




const url = `${API_BASE_URL}/master/assets/uploads/`;


export default function ContactUsThankYou() {
    const userData = JSON.parse(localStorage.getItem('userData'));

    const [eventsData, setEventData] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);

        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();

        // Helper to get ordinal suffix
        const getOrdinal = (n) => {
            if (n > 3 && n < 21) return 'th';
            switch (n % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };

        return `${day}${getOrdinal(day)}, ${month} ${year}`;
    };

    const fetchUpcomingEvents = async (lat, lng, date) => {
        try {
            const formData = new FormData();
            formData.append('latitude', lat);
            formData.append('longitude', lng);
            formData.append('date', date);

            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubEvent/upcomingEvents`,
                formData
            );

            if (response.data.status === true) {
                console.log('Upcoming Events:', response.data.data);
                setEventData(response.data.data); // ✅ Save to state
            } else {
                console.warn('No events found:', response.data.msg);
                setEventData([]); // Clear if no events
            }
        } catch (error) {
            console.error('Error fetching upcoming events:', error);
            setEventData([]);
        }
    };

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const latStr = latitude.toString();
                    const lngStr = longitude.toString();

                    setLatitude(latStr);
                    setLongitude(lngStr);

                    fetchUpcomingEvents(latStr, lngStr, today);
                },
                (error) => {
                    alert('Please enable Geo Location Service to find events in your locality.');
                    console.error('Error in finding location:', error);
                }
            );
        } else {
            console.error('Geolocation is not available in this browser.');
        }
    }, []);



    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        return `/event/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }


    return (
        <div className="package-lead-submitted-container">
            <ShowSuccess
                message='Thank You for Reaching Out!'
                thanksyouMessage='We’ve received your message and our team will get back to you shortly—usually within 24–48 hours. Your inquiry means a lot to us, and we’re excited to help you plan something unforgettable.'
            />


            {!userData && (
                <Link to='/login' style={{ textDecoration: 'none', width: '100%' }}>
                    <div className="contact-us-detail-page-design-bottom-banner" style={{ backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <div>
                            <span className="contact-us-detail-page-design-bottom-banner-text">Sign Up & Save Big</span>
                            <h1 className="contact-us-detail-page-design-bottom-banner-text-2">on Your First Booking</h1>
                        </div>
                        <div>
                            <h6 className="contact-us-detail-page-design-bottom-banner-text-offer">Click Join Boom 500🥕 in Your wallet</h6>
                        </div>
                    </div>
                </Link>
            )}
            <div className="event-cards-container">
                <div className="event-happening-title">
                    <h1>Events happening on {formatDate(today)}</h1>
                    <Link to='/today-events'>
                        <p>view all</p>
                    </Link>
                </div>

                <div className="event-cards-thank-you-page">
                    {eventsData.slice(0, 3).map((event, index) => (
                        <Link to={generateClubUrl(event.clubName, event.cityName, event.areaName, event.name)} key={index} >
                            <EventsListingCard title={event.name} date={event.event_date} time={event.event_time} rating={event.rating} location={event.cityName} distance={event.distance} type={event.categoryName} price={event.min_price} image={url + event.image} offer={event.offer}
                                eventid={event.id} clubid={event.club_id} />
                        </Link>
                    ))}
                </div>
            </div>
            <div>
                <FaqSection />
            </div>
            <a href="https://wa.me/+918299619469" target="_blank">
                <div className="rbfssp-whatsapp-section">
                    <BsWhatsapp className="rbfssp-whatsapp-icon" />
                </div>
            </a>

        </div>
    )

}